import RemediationBox from '../RemediationBox';
import { REMEDIATION_CONSTANTS } from '../NRRemediation.constants';
import React from 'react';
import Box from '@mui/material/Box';

function NRCryptographyRemediationStepOne() {
  return (
    <Box my={5}>
      <RemediationBox
        title={REMEDIATION_CONSTANTS.CRYPTO_STATUS.LABELS.UNSPECIFIED}
        optValue={REMEDIATION_CONSTANTS.CRYPTO_STATUS.VALUES.UNSPECIFIED}
        subtitle={REMEDIATION_CONSTANTS.CRYPTO_STATUS.DESCRIPTIONS.UNSPECIFIED}
        showAlert={REMEDIATION_CONSTANTS.CRYPTO_STATUS.SHOW_ALERT.UNSPECIFIED}
      />
      <RemediationBox
        title={REMEDIATION_CONSTANTS.CRYPTO_STATUS.LABELS.IN_PROGRESS}
        optValue={REMEDIATION_CONSTANTS.CRYPTO_STATUS.VALUES.IN_PROGRESS}
        subtitle={REMEDIATION_CONSTANTS.CRYPTO_STATUS.DESCRIPTIONS.IN_PROGRESS}
        showAlert={REMEDIATION_CONSTANTS.CRYPTO_STATUS.SHOW_ALERT.IN_PROGRESS}
      />
      <RemediationBox
        title={REMEDIATION_CONSTANTS.CRYPTO_STATUS.LABELS.REMEDIATED}
        optValue={REMEDIATION_CONSTANTS.CRYPTO_STATUS.VALUES.REMEDIATED}
        subtitle={REMEDIATION_CONSTANTS.CRYPTO_STATUS.DESCRIPTIONS.REMEDIATED}
        showAlert={REMEDIATION_CONSTANTS.CRYPTO_STATUS.SHOW_ALERT.REMEDIATED}
      />
      <RemediationBox
        title={REMEDIATION_CONSTANTS.CRYPTO_STATUS.LABELS.RISK_ACCEPTED}
        optValue={REMEDIATION_CONSTANTS.CRYPTO_STATUS.VALUES.RISK_ACCEPTED}
        subtitle={REMEDIATION_CONSTANTS.CRYPTO_STATUS.DESCRIPTIONS.RISK_ACCEPTED}
        showAlert={REMEDIATION_CONSTANTS.CRYPTO_STATUS.SHOW_ALERT.RISK_ACCEPTED}
      />
      <RemediationBox
        title={REMEDIATION_CONSTANTS.CRYPTO_STATUS.LABELS.NOT_AFFECTED}
        optValue={REMEDIATION_CONSTANTS.CRYPTO_STATUS.VALUES.NOT_AFFECTED}
        subtitle={REMEDIATION_CONSTANTS.CRYPTO_STATUS.DESCRIPTIONS.NOT_AFFECTED}
        showAlert={REMEDIATION_CONSTANTS.CRYPTO_STATUS.SHOW_ALERT.NOT_AFFECTED}
      />
    </Box>
  );
}

export default NRCryptographyRemediationStepOne;

